import { useTranslation } from "@repo/i18n";
import type { GroupVenue } from "../publicApi";

/**
 * The cross-venue overflow proposal (R6): an EXPLICIT card naming the sister venue AND its own booking
 * mode (the differing-mode edge case — a REQUEST_TO_BOOK sister is visible BEFORE any switch). The
 * diner must TAP it to switch — the flow's `venueId` changes only on that tap, never a silent
 * server-side substitution. `mode` is read from the sister's own live slots.
 */
export function OverflowCard({
  venue,
  onSwitch,
}: {
  venue: GroupVenue;
  onSwitch: (venueId: string) => void;
}) {
  const { t } = useTranslation();
  const mode = venue.slots[0]?.bookingMode ?? "INSTANT_CONFIRM";
  const modeLabel =
    mode === "REQUEST_TO_BOOK"
      ? t("widget.booking.mode.request")
      : t("widget.booking.mode.instant");

  return (
    <div className="rsv-card">
      <h3>{venue.displayName}</h3>
      <span className="rsv-badge">{modeLabel}</span>
      <p className="rsv-summary">
        {t("widget.booking.overflow.body", { name: venue.displayName })}
      </p>
      <button type="button" className="rsv-button" onClick={() => onSwitch(venue.venueId)}>
        {t("widget.booking.overflow.cta", { name: venue.displayName })}
      </button>
    </div>
  );
}
